import { Button, Card, CardContent } from '@repo/ui';

import { useSignOut } from '@/hooks/auth/use-sign-out';
import { selectCurrentUser } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

import { AccessAdminsList } from './AccessAdminsList';
import { SwitchToAccessRoleButton } from './SwitchToAccessRoleButton';
import { TryAgainButton } from './TryAgainButton';

/**
 * Signing in and being allowed to do something are different questions, and
 * only the first is answered by the identity provider. Someone who reaches
 * this screen is authenticated, so sending them back to sign in again would
 * loop — they would return holding exactly the permissions they already have.
 */
export default function NoAccessPage({ email }: { email: string }) {
  const user = useAppSelector(selectCurrentUser);
  const signOut = useSignOut();

  return (
    <div className="flex h-full items-center justify-center overflow-y-auto px-4">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-5 py-10 text-center">
          <div className="flex flex-col gap-1">
            <span className="text-sm font-semibold text-primary">Cyrino Platform</span>
            <span className="text-base font-semibold">You do not have access yet</span>
          </div>

          <div className="flex flex-col gap-3 text-sm text-muted-foreground">
            <p>
              Cyrino Platform is where administrators add people and decide who can use each Cyrino
              application, and with which role.
            </p>
            <p>
              You are signed in as {email}, but no role has been granted to you, so there is nothing
              here to show yet.
            </p>
          </div>

          <AccessAdminsList />

          <TryAgainButton />

          <SwitchToAccessRoleButton heldRoles={user?.heldRoles ?? []} />

          <Button variant="outline" onClick={signOut}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
